import { useNavigate } from "react-router-dom";

export const useNavigateAlt = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (str: string, event?: any) => {
    if (
      event &&
      (event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1)
    ) {
      window.open(str, "_blank");
    } else {
      navigate(str, { state: event?.state });
    }
  };
};
